var Material = (function () {

  function deleteObject(ids) {
    return $.ajax({
      url: Url.action('api/materials'),
      type: 'DELETE',
      dataType: 'json',
      data: { ids: ids }
    })
        .done((r) => _refreshTable(true, ids))
        .fail((e) => _showError(e));
  };

  function _show(id) {
      var modal = ModalConductor.activate(MaterialViewModal, id,
      (id) => {
        deleteObject([id]).done(() => {
          modal.close();
        });
      })
    .on('closed', (modalResult) => {
      _refreshTable();
    });
  };

  function _delete(ids) {
    if (ids.length > 0 && confirm('Вы действительно хотите удалить {0} записей?'.format(ids.length))) {
      deleteObject(ids);
    }
  };

  function _add() {
      ModalConductor.activate(MaterialEditModal)
      .on('closed',
        (modalResult) => {
          if (modalResult.ok) {
            _refreshTable();
          }
        });
  };

    function _refreshTable(resetChecked, deselectOnlyId) {
        var table = $('#MaterialListItemViewModelTable').DataTable();
        refreshTable(table, resetChecked, null, deselectOnlyId);
    };

    function _showError(e) {
        var errorMessage = (e && e.responseJSON && e.responseJSON.Error)
            ? e.responseJSON.Error
            : 'При удалении произошла ошибка.';
        ModalConductor.activate(MessageModal, $('#message-tmpl').text(), 'Ошибка!', errorMessage);
    };

  return {
    show: _show,
    del: _delete,
    add: _add
  };
}());
